import React from 'react';

/** آیکون‌های ثابت طرح که از فیگما در public/blog/icons ذخیره شده‌اند */
export type BlogIconName =
  | 'search'
  | 'search-input'
  | 'close'
  | 'clear-x'
  | 'close-20'
  | 'chevron-left'
  | 'chevron-right-muted'
  | 'chevron-left-xs'
  | 'chevron-left-xxs'
  | 'chevron-left-sm-purple'
  | 'chevron-right-sm-muted'
  | 'chevron-down-xs'
  | 'chevron-down-16'
  | 'chevron-up-16'
  | 'chevron-all-articles'
  | 'arrow-left'
  | 'arrow-read-article'
  | 'breadcrumb-chevron'
  | 'sort'
  | 'sort-select'
  | 'clock'
  | 'clock-md'
  | 'clock-muted-sm'
  | 'clock-white-xs'
  | 'calendar'
  | 'calendar-md'
  | 'video-muted'
  | 'video-white'
  | 'video-purple'
  | 'video-badge-purple'
  | 'video-circle'
  | 'video-section'
  | 'video-error'
  | 'play'
  | 'share'
  | 'share-mobile'
  | 'share-step'
  | 'copy-link'
  | 'copy-mobile'
  | 'copy-sm'
  | 'lightbulb'
  | 'bookmark'
  | 'bookmark-step'
  | 'thumbs-up'
  | 'thumbs-down'
  | 'reply'
  | 'reply-sm'
  | 'comments'
  | 'comments-mobile'
  | 'send'
  | 'author-pen'
  | 'author-box'
  | 'toc-list'
  | 'toc-list-16'
  | 'toc-chevron'
  | 'empty-search'
  | 'empty-search-sm'
  | 'error-alert'
  | 'error-circle'
  | 'field-error'
  | 'retry'
  | 'retry-sm'
  | 'check-circle'
  | 'spinner'
  | 'toast-check'
  | 'login'
  | 'menu'
  | 'menu-sm'
  | 'play-mobile'
  | 'social-youtube'
  | 'social-instagram'
  | 'social-telegram'
  | 'footer-email'
  | 'footer-mail'
  | 'footer-podcast'
  | 'footer-podcast-sm'
  | 'footer-instagram'
  | 'footer-telegram'
  | 'footer-rss';

interface BlogIconProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  name: BlogIconName;
  width: number;
  height: number;
  /** برای آیکون‌های معنادار؛ آیکون‌های تزئینی alt خالی دارند */
  label?: string;
}

const BASE = `${process.env.PUBLIC_URL || ''}/blog/icons`;

/** متغیرهای CSS ریشهٔ صفحات وبلاگ (آیکون کادر «نکته کلیدی» در blog.css) */
export const BLOG_PAGE_STYLE = {
  '--blog-callout-icon': `url(${BASE}/lightbulb.svg)`,
  '--blog-callout-icon-mobile': `url(${BASE}/lightbulb-mobile.svg)`,
  '--blog-exercise-icon-odd': `url(${BASE}/share-step.svg)`,
  '--blog-exercise-icon-even': `url(${BASE}/bookmark-step.svg)`,
} as React.CSSProperties;

const BlogIcon: React.FC<BlogIconProps> = ({ name, width, height, label, className = '', style, ...rest }) => (
  <img
    src={`${BASE}/${name}.svg`}
    alt={label || ''}
    aria-hidden={label ? undefined : true}
    width={width}
    height={height}
    draggable={false}
    className={`inline-block shrink-0 select-none ${className}`}
    style={{ width, height, ...style }}
    {...rest}
  />
);

export default BlogIcon;
